export const dynamicPricing = {
  title: "Precios Dinámicos",
  loading: "Cargando configuración…",
  status: {
    active: "Activo",
    inactive: "Inactivo",
  },
  close: "Cerrar",
  unit: {
    label: "Alojamiento",
    autoPill: "✦ Auto desde tu histórico",
  },
  tabs: {
    calendario: "Calendario",
    precio: "Precio base",
    reglas: "Reglas",
    aplicacion: "Aplicación",
  },
  weekdaysShort: {
    mon: "Lun",
    tue: "Mar",
    wed: "Mié",
    thu: "Jue",
    fri: "Vie",
    sat: "Sáb",
    sun: "Dom",
  },
  cal: {
    stats: {
      adr: "ADR proy.",
      occupancy: "Ocupación",
      revenue: "Ingresos",
    },
    calculating: "Calculando precios…",
    minStayShort: "mín. {count}n | mín. {count}n",
  },
  legend: {
    low: "Bajo",
    base: "Base",
    high: "Alto",
    peak: "Pico",
    booked: "Reservado",
    override: "Fijo",
  },
  why: {
    title: "Por qué {price} {curr} · {day}",
    chip: "explicación",
    nights: "{count} noche | {count} noches",
    minStay: "Estancia mínima: {nights} · suelo {floor} / techo {ceil} {curr}",
    hint: "Toca un día para ver el desglose de su precio.",
  },
  apply: {
    diffPrefix: "Con los precios sugeridos:",
    diffSuffix: "frente a tus precios actuales de {month}.",
    apply: "Aplicar precios",
    applying: "Aplicando…",
    applyNow: "Aplicar ahora",
    enableToApply: "Activa Precios Dinámicos para aplicar.",
    enableFirst: "Activa Precios Dinámicos primero.",
    autoNote: {
      prefix: "✓ En modo",
      mode: "Automático",
      mid: "se aplican",
      everyday: "cada día",
    },
    result: {
      hotelPending: "Los hoteles (varias unidades) aún no están soportados en esta fase.",
      ok: "✓ Aplicado {count} día ({from} → {to}) y enviado a canales. | ✓ Aplicados {count} días ({from} → {to}) y enviados a canales.",
      failed: "No se pudieron aplicar los precios.",
    },
  },
  base: {
    title: "Precio base y límites",
    desc: "Sugeridos desde tu histórico. El motor nunca sale de este rango.",
    basePerNight: "Base / noche",
    min: "Mínimo (suelo)",
    max: "Máximo (techo)",
    rounding: "Redondeo",
  },
  rounding: {
    integer: "Entero",
    ends0: "Acaba en 0",
    ends9: "Acaba en 9",
    multiple5: "Múlt. 5",
  },
  weekend: {
    title: "Fin de semana y estancia mínima",
    upliftLabel: "Incremento de fin de semana",
    daysLabel: "Días de fin de semana:",
    minStayLabel: "Estancia mínima (noches)",
    minStayNormal: "Normal",
    minStayWeekend: "Findes / alta",
    orphanTitle: "Rellenar noches huérfanas",
    orphanDesc: "Estancias más cortas ({pct} % dto.) en huecos de 1–2 noches.",
  },
  demand: {
    title: "Sensibilidad a la demanda",
    desc: "Cuánto mueven el precio la ocupación y el ritmo de reservas.",
  },
  aggr: {
    low: "Conservador",
    medium: "Medio",
    high: "Agresivo",
  },
  seasons: {
    title: "Temporadas",
    namePlaceholder: "Nombre",
    monthDayPlaceholder: "MM-DD",
    add: "+ Añadir temporada",
  },
  events: {
    title: "Eventos (ferias, festivales…)",
    suggestWithAI: "✨ Sugerir con IA",
    suggesting: "Buscando…",
    namePlaceholder: "Nombre",
    datePlaceholder: "AAAA-MM-DD",
    empty: "Sin eventos. Añádelos a mano o con IA.",
    add: "+ Añadir evento",
    suggestionsHead: "Sugerencias IA{city} — revisa fechas y añade",
    addSuggestion: "+ Añadir",
    noSuggestions: "Sin sugerencias (revisa que el alojamiento tenga ciudad configurada).",
  },
  demandRules: {
    title: "Reglas de demanda",
    lastMinuteTitle: "Descuentos last-minute",
    lastMinuteDesc: "Baja el precio de fechas próximas aún libres.",
    holidaysTitle: "Festivos automáticos",
    holidaysDesc: "Aplica +{pct} % en festivos nacionales.",
    occupancyTitle: "Subir por ocupación",
    occupancyDesc: "Si el mes supera el {threshold} % lleno, sube el precio.",
    weeklyDiscount: "Dto. semanal (7+) %",
    monthlyDiscount: "Dto. mensual (28+) %",
  },
  application: {
    title: "Modo y sincronización",
    modeLabel: "Modo de aplicación",
    modeSuggested: "Sugerido (reviso antes)",
    modeAuto: "Automático",
    syncTitle: "Sincronizar a canales (Channex → Airbnb / Booking)",
    syncDesc: "Publica los precios calculados en tus canales.",
    horizonLabel: "Horizonte de cálculo",
    horizonMonths: "{count} meses",
  },
  save: {
    saved: "Guardado ✓",
    saving: "Guardando…",
    save: "Guardar cambios",
  },
  errors: {
    forbidden: "No tienes acceso a este alojamiento.",
    loadFailed: "No se pudo cargar la configuración.",
    saveFailed: "No se pudo guardar. Revisa los campos.",
  },
};
